<template>
  <div>
    Please use <a :href="loginSamlUrl">the Login link</a> if you aren't forwarded to login page.
  </div>
</template>

<script>
import { useContextStore } from '@/stores/context';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  setup() {
    const context = useContextStore();
    const route = useRoute();

    // Set the login method to SAML
    context.currentLoginMethod = 'auth-saml';

    const returnPath = computed(() => {
      let path = route.query.returnPath || '/';
      if (path === '/auth-saml/login') path = '/';
      return path;
    });

    const loginSamlUrl = computed(() => {
      const query = new URLSearchParams({ returnPath: returnPath.value });
      return `${context.loginRedirectUrl}/api/auth-saml/login?${query.toString()}`;
    });

    window.location.href = loginSamlUrl.value;

    return {
      returnPath,
      loginSamlUrl,
    };
  },
};
</script>
